import styled from 'styled-components';

import Layout from '@/components/Base/Layout';

export const LayoutStyles = styled(Layout)`
  display: block;
  padding-right: 16px;
  padding-left: 16px;

  & > div {
    gap: 16px;
  }
`;

export const BreadcrumbsWrapper = styled.div`
  width: 100%;
  padding: 16px;
`;
